import React, { useState, useEffect } from "react";

import { useNavigate } from 'react-router-dom';
import { Form, Button, Container, Row, Col, Card, InputGroup } from "react-bootstrap";
import { collection, addDoc } from "firebase/firestore";
import { auth, db } from "../firebaseConfig";
import { signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { FaEye, FaEyeSlash, FaStore, FaLock } from "react-icons/fa";

const LoginAdmin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // If user is already logged in, redirect to dashboard
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        navigate("/Dashboard/AddProducts");
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Any user in Firebase Auth is an admin - no extra checks needed
      await signInWithEmailAndPassword(auth, email, password);

      // Log login event
      try {
        await addDoc(collection(db, "adminLogins"), {
          email: email,
          loginTime: new Date().toISOString(),
        });
      } catch (logError) {
        console.error("Error adding document: ", logError);
      }

      navigate("/Dashboard/AddProducts");
    } catch (error) {
      console.error("Login Error: ", error);
      alert("Invalid credentials: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ backgroundColor: "#F3F4F6", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} md={8} lg={5}>
            <div className="text-center mb-4">
              <div className="d-inline-flex align-items-center justify-content-center bg-white rounded-circle shadow-sm mb-3" style={{ width: "80px", height: "80px", color: "#C62828" }}>
                <FaStore size={36} />
              </div>
              <h2 className="fw-bold" style={{ color: "#111827", fontFamily: "'Playfair Display', serif" }}>Kamdhenu Admin</h2>
              <p className="text-muted">Sign in to manage your store</p>
            </div>

            <Card className="border-0 shadow-lg" style={{ borderRadius: "16px", overflow: "hidden" }}>
              <Card.Body className="p-4 p-md-5 bg-white">
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-4">
                    <Form.Label className="fw-medium text-secondary" style={{ fontSize: "0.9rem" }}>Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="admin@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className="py-2"
                      style={{ borderRadius: "8px", border: "1px solid #E5E7EB", boxShadow: "none" }}
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label className="fw-medium text-secondary" style={{ fontSize: "0.9rem" }}>Password</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder="••••••••"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="py-2 border-end-0"
                        style={{ borderRadius: "8px 0 0 8px", border: "1px solid #E5E7EB", boxShadow: "none" }}
                      />
                      <InputGroup.Text
                        style={{ cursor: "pointer", backgroundColor: "white", borderRadius: "0 8px 8px 0", border: "1px solid #E5E7EB", borderLeft: "none" }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FaEyeSlash className="text-muted" /> : <FaEye className="text-muted" />}
                      </InputGroup.Text>
                    </InputGroup>
                  </Form.Group>

                  <Button
                    type="submit"
                    className="w-100 py-2 d-flex align-items-center justify-content-center gap-2 fw-bold"
                    disabled={loading}
                    style={{ backgroundColor: "#C62828", border: "none", borderRadius: "8px", transition: "all 0.2s" }}
                  >
                    {loading ? "Signing in..." : <><FaLock size={14} /> Sign In to Dashboard</>}
                  </Button>
                </Form>
              </Card.Body>
            </Card>

            <div className="text-center mt-4 text-muted" style={{ fontSize: "0.85rem" }}>
              &copy; {new Date().getFullYear()} Shree Kamdhenu Furniture. All rights reserved.
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LoginAdmin;
